export function formatarDuracaoConteudo(duracao: string) {
  const hours = Math.trunc(Number(duracao || 0) / 60);
  const minutes = Number(duracao || 0) % 60;
  return `${hours}h ${minutes}min `;
}
